const AdminSideBarLinks = [
  { href: "/admin", title: "대시보드", icon: "📊" },
  { href: "/admin/user", title: "유저 관리", icon: "👥" },
  { href: "/admin/service", title: "서비스 관리", icon: "🛒" },
  { href: "/admin/booking", title: "예약 관리", icon: "📅" },
  { href: "/admin/payment", title: "결제 관리", icon: "💳" },
  { href: "/admin/faq", title: "문의 관리", icon: "💬" },
  { href: "/admin/report", title: "신고 관리", icon: "🚨" },
  { href: "/admin/withdraw", title: "출금 관리", icon: "💰" },
];

export default AdminSideBarLinks;
